import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

interface UseMergeTagsMutationOptions {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
	impersonationContext?: Api.IImpersonationContext;
}

interface MergeTagsParams {
	sourceTagValues: string[];
	targetTagValue: string;
}

export function useMergeTagsMutation({ onSuccess, onError, impersonationContext }: UseMergeTagsMutationOptions) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({ sourceTagValues, targetTagValue }: MergeTagsParams) => {
			return userSession.webServiceHelper.callAsync<Api.IOperationResultNoValue>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'tag/merge',
				}),
				'POST',
				{
					sourceTags: sourceTagValues,
					intoTag: targetTagValue,
				}
			);
		},
		onSuccess,
		onError,
	});
}
